import { parsePhoneNumberWithError } from "libphonenumber-js";
import { trackBrowserNotification } from '../utils/notificationRegistry';
import { playNotificationSound } from '../utils/notificationSound';

const scrollToExtreme = (direction) => {
    if (direction === "up") {
        window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (direction === "down") {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    } else if (direction === "left") {
        window.scrollTo({ left: 0, behavior: "smooth" });
    } else if (direction === "right") {
        window.scrollTo({ left: document.body.scrollWidth, behavior: "smooth" });
    } else {
        console.error("Invalid direction. Use 'up', 'down', 'left', or 'right'.");
    }
};

function getCountryCode(phoneNumber) {
    phoneNumber = phoneNumber.replaceAll("+", "");
    phoneNumber = phoneNumber[0] == '0' ? phoneNumber.replace("0", "971") : phoneNumber;

    // Add a "+" sign to the phone number to make it a valid international format
    const internationalPhoneNumber = `+${phoneNumber}`;

    // Parse the phone number
    const parsedNumber = parsePhoneNumberWithError(internationalPhoneNumber);

    // Check if the number is valid
    if (!parsedNumber) {
        // alert(internationalPhoneNumber)
        throw new Error('Invalid phone number');
    }

    // Return the country code (e.g., "IN" for India)
    // return parsedNumber.country == 'AE' ? 'ARE' : parsedNumber.country;
    return parsedNumber.country;
};

const openNewTab = (url) => {
    if (!url) {
        console.error("You forgot the URL, dummy!");
        return;
    }
    window.open(url, '_blank').focus();
}

const playChime = (file) => {
    return playNotificationSound(file);
};

const showNotification = (main, body, logo, options = {}) => {
    if (typeof Notification !== "undefined" && Notification.permission === "granted") {
        const systemNotification = new Notification(main ? main : "Hello!", {
            body: body ? body : "This is a system-level notification.",
            icon: logo
                ? logo
                : "https://www.uzdpart.com/wp-content/themes/uzdpart-child/assets/images/logo.PNG",
            tag: options.tag,
        });
        if (typeof options.onClick === "function") {
            systemNotification.onclick = () => {
                window.focus();
                options.onClick();
                systemNotification.close();
            };
        }
        return trackBrowserNotification(systemNotification);
    } else {
        console.log("Notification permission not granted.");
        return null;
    }
};

const generatePDF = (...args) => import('./exports/pdfExports').then(module => module.generatePDF(...args));
const generateExcel = (...args) => import('./exports/excelExports').then(module => module.generateExcel(...args));
const generateQv4QueriesPdfBase64 = (...args) => import('./exports/pdfExports').then(module => module.generateQv4QueriesPdfBase64(...args));
const generateQv4QueriesExcel = (...args) => import('./exports/excelExports').then(module => module.generateQv4QueriesExcel(...args));

export {
    scrollToExtreme,
    getCountryCode,
    openNewTab,
    playChime,
    showNotification,
    generatePDF,
    generateExcel,
    generateQv4QueriesPdfBase64,
    generateQv4QueriesExcel,
};
